/** Created by azhou on 2019/3/14.*/
<template>
  <div>
    <public-title>门店评论列表</public-title>
    <div class="load-area">
      <gcon-search @getSearchCon="getSearchCon" />
      <p v-if="StoreLists.total<=0">当前没有数据</p>
      <div v-else>
        <ul class="list-head"><li class="w-50" v-for="item in titleArr" :key="item">{{item}}</li></ul>
        <ul class="list-item" v-for="Itemize in StoreLists.lists" :key="Itemize.id">
          <li class="w-50 list-item-col">
            <span class="text-link" @click="goStoreDetail(Itemize.store_id)">{{Itemize.title}}</span>
          </li>
          <li class="w-50 list-item-col">{{Itemize.no_comment_nums || Itemize.beComment}}</li>
          <li class="w-50 list-item-col">{{Itemize.in_comment_nums || Itemize.comment}}</li>
          <li class="w-50 list-item-col" :class="[Itemize.verify === 1 ? 'text-success' : 'text-danger']">
            {{Itemize.verify | formatVar('verifyType')}}
          </li>
          <li class="w-50 list-item-col">
            {{Itemize.province_name}}-{{Itemize.city_name}}-{{Itemize.district_name}}
          </li>
          <li class="w-50 list-item-col-end">
            <span class="text-link" @click="goForDetail(Itemize)">查看</span>
          </li>
        </ul>
        <el-pagination background layout="prev, pager, next" class="mt-4"
                       :total="StoreLists.total" :current-page="Number(queryCon.page)"
                       @current-change="v => this.$router.push({name:this.$route.name,query:{page:v}})"/>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters,mapState, mapActions } from 'vuex'
  import GconSearch from '../GconSearch'

  export default {
    name: 'GroupBankcardList',
    components: { GconSearch },
    computed: {
      ...mapState(['StoreLists']),
      ...mapGetters(['storeInfo']),
      queryCon() { return this.$route.query },
      travel () { return this.storeInfo.type == 2 },
      titleArr() {
        switch (this.storeInfo.type) {
          case 2: return ['门店名称','待评论','已评论','门店认证','所在地','操作'];
          default: return ['门店名称','待回复','已回复','门店认证','所在地','操作'];
        }
      }
    },
    watch:{
      queryCon() {
        if (this.travel) this.TraGroupGetStoreLists({ url: this.url, data: {...this.info} })
        else this.groupGetStoreLists({ page:this.queryCon.page, type:10, ...this.info })
      },
    },
    data() {
      return {
        info: {},
        url: '/pc/Travel/storeDiscuss'
      }
    },
    created() {
      if (this.queryCon.hasOwnProperty('page')) {
        if (this.travel) this.TraGroupGetStoreLists({ url: this.url})
        else this.groupGetStoreLists({ page:this.queryCon.page, type:10 })
      } else {
        if (this.travel) this.TraGroupGetStoreLists({ url: this.url, data: {page:1} })
        else this.groupGetStoreLists({ page:1, type:10 })
      }
    },
    methods:{
      ...mapActions(['groupGetStoreLists','TraGroupGetStoreLists']),
      //查看门店银行卡列表
      goForDetail(item) {
        this.$router.push({name:this.$route.name,query:{...this.$route.query,store:item.store_id,page:1,GST:item.title}})
      },
      //查看门店详情页
      goStoreDetail(id) {
        let routeUrl = this.$router.resolve({name:'StoreDetail',query:{type:this.storeInfo.type,id}});
        window.open(routeUrl.href, '_blank');
      },
      getSearchCon (info) {
        this.info=info;
        if (this.travel) this.TraGroupGetStoreLists({ url: this.url, data: {page:1, ...info} })
        else this.groupGetStoreLists({ page:1, type:10, ...info })
      }
    }
  }
</script>
